export default __webpack_public_path__ + "static/media/cwu5.7ff97ae2.jpeg";